import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { styled, useTheme } from '@mui/material/styles';
import {
  Stack, 
  Stepper, 
  Step, 
  StepLabel,
  StepConnector, 
  stepConnectorClasses} from '@mui/material';
import Check from '@mui/icons-material/Check';
import PropTypes from 'prop-types';
import stepperStyles from './Stepper.styles';
import StepperContext from '../Context/StepperContext';

//Customhook
import { useTranslation } from '../../hooks/useTranslation';

function StepperBar(props) {
  const location = useLocation();
  const showBox = /^\/accounts(\/.*)?$/.test(location.pathname) ||  /^\/home\/?$/.test(location.pathname) || /^\/NoAccountFound(\/.*)?$/.test(location.pathname);
  const theme = useTheme();
  const { t, translations } = useTranslation();
  const { currentStep } = useContext(StepperContext);
  // To prevent flicker
  if (!translations || !translations.common || !translations.common.labels) {
    return null;
  }
  
  const steps = [
    t('common.labels.register'),
    t('common.labels.selectAccounts'),
    t('common.labels.approveConsents')
  ];

  function QontoStepIcon(propss) {
    const { completed, className, icon } = propss;
    const stepIndex = Number(icon) - 1; 
    const isCurrent = stepIndex === currentStep;
  
    const QontoStepIconRoot = styled('div')(() => ({
      color: isCurrent ? props.customDetails?.primaryColor : '#eaeaf0',
      display: 'flex',
      height: 22,
      alignItems: 'center',
      '& .QontoStepIcon-completedIcon': {
        color: props.customDetails?.primaryColor,
        zIndex: 1,
        fontSize: 18,
      },
      '& .QontoStepIcon-circle': {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
      },
    }));
  
    return (
      <QontoStepIconRoot className={className}>
        {completed ? (
          <Check className="QontoStepIcon-completedIcon" />
        ) : (
          <div className="QontoStepIcon-circle" />
        )}
      </QontoStepIconRoot>
    );
  }

  QontoStepIcon.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    completed: PropTypes.bool,
    icon: PropTypes.node,
  };

  const QontoConnector = styled(StepConnector)(() => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 10,
      left: 'calc(-50% + 16px)',
      right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: props.customDetails?.primaryColor,
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: props.customDetails?.primaryColor,
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#eaeaf0',
      borderTopWidth: 3,
      borderRadius: 1,
    },
  }));

  let loginPage = props.login;

  return (
    <Stack
      sx={{
        ...stepperStyles.stepperContainer,
        ...(loginPage && {
          position: 'absolute',
          top: '60px',
          left: '0',
          padding: '20px !important',
        }),
        backgroundColor: showBox ? theme.palette.primary.light : 'transparent',
        '& .MuiStepLabel-label.MuiStepLabel-alternativeLabel': {
          marginTop: 0,
          color: props.customDetails?.primaryColor,
          fontWeight: 400,
        },

        '& .MuiStepConnector-root.Mui-active .MuiStepConnector-line': {
          borderColor: props.customDetails?.primaryColor, 
        },
      }}
      spacing={4}
    >
      <Stepper 
       alternativeLabel 
       activeStep={currentStep} 
       connector={<QontoConnector/>}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={QontoStepIcon}>
              <span style={{marginTop : 0}}>{label}</span>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
  );
}

export default StepperBar;
